<template>
  <div class="b-faq">
    <div class="b-faq__items">
      <div
        v-for="(question, index) in questions"
        :key="index"
        class="b-faq__item"
        :class="{ 'b-faq__item-header-title--active': expanded(index)}"
        @click="onSelectQuestion(index)"
      >
        <div class="b-faq__item-header">
          <div class="b-faq__item-header-icon-left">
            {{ index + 1 }}
          </div>
          <div
            class="b-faq__item-header-title"
            v-html="question.question"
          />
          <div class="b-faq__item-header-icon-right">
            <svg-icon src="icon-new-lk_icon-chevron-down-medium" />
          </div>
        </div>
        <TransitionCollapse>
          <div
            v-if="expanded(index)"
            class="b-faq__item-body"
            v-html="question.answer"
          />
        </TransitionCollapse>
      </div>
    </div>
  </div>
</template>

<script>
import TransitionCollapse from '@/components/core/ui/TransitionCollapse.vue'

export default {
  name: 'FAQ',
  components: {
    TransitionCollapse,
  },
  props: {
    questions: {
      type: Array,
      default () {
        return []
      },
    },
  },
  data () {
    return {
      selectedQuestion: null,
    }
  },
  methods: {
    expanded (index) {
      return index === this.selectedQuestion
    },
    onSelectQuestion (index) {
      if (index === this.selectedQuestion) {
        this.selectedQuestion = null
      } else {
        this.selectedQuestion = index
      }
    },
  },
}
</script>

<style lang="scss">
.b-faq {
  padding-left: 0.24rem;
  padding-right: 0.24rem;
}

.b-faq__items{
  display: flex;
  flex-flow: row wrap;
}

.b-faq__item{
  flex: 0 0 100%;
  max-width: 100%;
  padding-top: 0.18rem;
  padding-bottom: 0.18rem;
  border-bottom: 1px solid map-get($colors, 'grey_4');
}

.b-faq__item-header{
  position: relative;
}

.b-faq__item-header-icon-left{
  position: absolute;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  left: 0;
  width: 0.2rem;
  height: 0.2rem;
  background-color: map-get($colors, 'green_10');
  border-radius: 50%;
  font-size: 0.09rem;
  line-height: 0.08rem;
  font-weight: 500;
  color: map-get($colors, 'default');
}

.b-faq__item-header-title{
  font-size: 0.14rem;
  line-height: 0.2rem;
  font-weight: 700;
  padding-left: 0.36rem;
  padding-right: 0.24rem;

  transition: color .15s;

  &--active &{
    color: map-get($colors, 'default');
  }
}

.b-faq__item-header-icon-right{
  position: absolute;
  top: 0.08rem;
  right: 0;
  color:  map-get($colors, 'grey_20');

  .c-icon{
    width: 0.1rem;
    height: 0.05rem;
    transition: transform .2s ease-in-out;

    .active & {
      transform: rotate(180deg);
    }
  }
}

.b-faq__item-body{
  padding-top: 0.08rem;
  font-size: 0.14rem;
  line-height: 0.2rem;
  font-weight: 500;
  color: map-get($colors, 'grey_60');
}
</style>
